import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const TestimonialSection = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  const cardStyle = {
    backgroundColor: '#6C63FF',
    borderRadius: '10px',
    overflow: 'hidden',
  };

  const cardBodyStyle = {
    padding: '2rem 3rem',
    textAlign: 'center',
  };

  const imageStyle = {
    border: '3px solid #fff',
    height: '150px',
    width: '150px',
    borderRadius: '50%',
    objectFit: 'cover',
    margin: '0 auto',
  };

  const figureStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0',
    padding: '0',
  };

  const blockquoteStyle = {
    fontSize: '1.25rem',
    fontWeight: '400',
    lineHeight: '1.6',
    marginBottom: '1.5rem',
  };

  const ratingStyle = {
    fontSize: '1.25rem',
    marginBottom: '1.5rem',
  };

  const figcaptionStyle = {
    textAlign: 'center',
    marginTop: '1rem',
  };

  const nameStyle = {
    fontSize: '1.2rem',
    color: '#fff',
    marginBottom: '0.5rem',
  };

  const titleStyle = {
    fontSize: '1rem',
    color: '#dcdcdc',
    marginBottom: '0',
  };

  return (
    <section className="py-1 py-md-5 py-xl-8 mt-0">
      <div className="container overflow-hidden">
        <div className="row gy-3 gy-lg-4">
          <div className="col-12">
            <Slider {...settings}>
              {testimonials.map((testimonial, index) => (
                <div className="text-center mb-2" key={index}>
                  <div className="card text-white border-0" style={cardStyle}>
                    <div className="card-body" style={cardBodyStyle}>
                      <div
                        className="bsb-ratings text-warning mb-3"
                        style={ratingStyle}
                        data-bsb-star={testimonial.stars}
                        data-bsb-star-off={5 - testimonial.stars}
                      ></div>
                      <blockquote className="bsb-blockquote-icon mb-3" style={blockquoteStyle}>
                        "{testimonial.quote}"
                      </blockquote>
                      <figure className="d-flex flex-column align-items-center" style={figureStyle}>
                        <img
                          className="img-fluid"
                          loading="lazy"
                          src={testimonial.imgSrc}
                          alt={testimonial.name}
                          style={imageStyle}
                        />
                        <figcaption style={figcaptionStyle}>
                          <h4 className="mb-1" style={nameStyle}>{testimonial.name}</h4>
                          <h5 className="fs-6" style={titleStyle}>{testimonial.title}</h5>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
};

const testimonials = [
  {
    stars: 5,
    quote:
      "When we stand for change, we ignite the potential to spark a powerful and widespread movement. This movement possesses the ability to wield significant influence, creating ripples that touch every corner of society. This movement draws upon the collective genius of individuals coming together, each contributing their unique talents and insights. United, we can achieve remarkable feats, inspire others, and create a legacy of transformation that resonates for generations.",
    imgSrc: "https://i.postimg.cc/6pDZyPDq/sakshi.jpg",
    name: "Sakshi Rathi",
    title: "PICT alumni",
  },
  {
    stars: 4,
    quote:
      "My time as a volunteer with PICT NSS has been the best time of my life. Handling responsibilities like getting permissions from the administration, arranging things for events, and managing teams taught me so much. These experiences have made me a better person and have also been very helpful in my career. I always look back fondly with time and try to visit whenever I can because I love my juniors.",
    imgSrc: "https://i.postimg.cc/QChrsKJ7/Whats-App-Image-2024-07-11-at-16-07-57-f842977a.jpg",
    name: "Jayant Khandebharad",
    title: "PICT alumni",
  },
  {
    stars: 3,
    quote:
      "माझ्या आयुष्या मधील NSS शिबिरामध्ये मुलांबरोबरचा पहिला अनुभव होता. मी या शिबिरामध्ये काही तासच होतो. या सात दिवसांच्या शिबिरामध्ये प्रतिकूल परिस्थितीमध्ये मुले आणि मुली राहून समाजसेवा करतात. श्री अमोल इंगोले सरांच्या नेतृत्वाखाली जवळपास ५० मुला-मुलांनी एकत्रित येऊन बरीच सामाजिक उपक्रम गावामध्ये केली. त्यामध्ये लोकांना आर्थिक, सामाजिक, बालिका सबलीकरण याचे महत्त्व प्रत्येकाशी बोलून किंवा सगळ्यांना रात्री एकत्र बोलवून पथनाट्यद्वारे सांगितले. काही मुले-मुली दिवसभर गावामध्ये असे बरेच उपक्रम राबवतात आणि काही मुलांचा समूह त्या बाकीच्या मुलांसाठी जेवण तयार करणे हे असे आळीपाळीने करून हा उपक्रम नेटाने राबवणे यामधूनच सामाजिक बांधिलकी आणि एकत्रित काम करण्याची प्रवृत्ती दिसून येते.",
    imgSrc: "https://i.postimg.cc/WzzX55wf/Whats-App-Image-2024-07-12-at-14-13-21-d4794beb.jpg",
    name: "ललित पाटील",
    title: "Faculty",
  },
  {
    stars: 5,
    quote:
      "We Love Care Share Foundation is extremely delighted to collaborate with NSS-PICT. This year was filled with many wonderful collaborations and events for the LCS team, and working with the NSS unit was both a great learning and fun experience. The foundation had a wonderful time partnering on events such as Raksha Bandhan with Army soldiers, Fire Brigade officers, and residents of an old age home, as well as a cleanliness drive at Katraj Lake and Palkhi crowd management. It was due to the immense hard work and dedication of the NSS-PICT team that these events were executed successfully.",
    imgSrc: "https://i.postimg.cc/brNTrMcg/Whats-App-Image-2024-07-14-at-22-52-12-73b77b37.jpg",
    name: "Piyush Shah",
    title: "Love Care Share Foundation",
  },
];

export default TestimonialSection;
